import { Box, Button, Grid, Tooltip, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import SearchIcon from "@mui/icons-material/Search";
import GlobalCard from "../../components/GlobalCardComponent";
import Loader from "../../../SAPPages/components/Loader/Loader";
import {
  removeOneItem,
  removeWishlistAllItem,
} from "../testPrepDashboard/Api/DashboardApi";
import WishlistEmpty from "./WishlistEmpty";
import { useDispatch, useSelector } from "react-redux";
import { CLEAR_WISHLIST, REMOVE_FROM_WISHLIST } from "../../../actions";
import CustomPafinationComp from "../allClasses/CustomPafinationComp";
import { useNavigate } from "react-router-dom";
import CustomSnackbar from "../../../newTestPreo/components/snackbar/Snackbar";
import ConfimationPopup from "../../components/customPopup/ConfimationPopup";
import DeleteAllConfirmation from "./DeleteAllConfirmation";
import GlobalMessageModal from "../../components/customPopup/GlobalMessageModal";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { useSnackbar } from "../../components/snackbars/SnackbarContext";

export default function TestPrepWishList() {
  const { items: wishlistItems, loading } = useSelector(
    (state) => state.wishlist
  );
  console.log("loading", loading);

  const [cardData, setCardData] = useState(wishlistItems);

  const dispatch = useDispatch();
  const userId = localStorage.getItem("userId");
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);
  const navigate = useNavigate();
  const [openConfimation, setOpenConfirmation] = useState(false);
  const [openSuccesPopup, setOpenSuccesPopup] = useState(false);

  const { showSnackbar } = useSnackbar();


  // feth data

  useEffect(() => {
    setCardData(wishlistItems);
  }, [wishlistItems]);

  // ✅ remove one item from wishlist
  const handleRemoveOneItem = async (classId) => {
    try {
      const payload = {
        service_id: 1,
        class_id: classId,
        is_adding: false, // remove only
        user_id: parseInt(userId),
      };

      const response = await removeOneItem(payload);

      if (response.status === 200) {
        showSnackbar(response.message, "success");
        //  update redux

        dispatch({ type: REMOVE_FROM_WISHLIST, payload: classId });


        // update local UI
        setCardData((prev) => prev.filter((item) => item.id !== classId));
      } else if ([400, 401, 500].includes(response.status)) {
        showSnackbar(response.message || "Something went wrong", "error");
      }
    } catch (error) {
      showSnackbar("Something went wrong", "error");
    }
  };

  // pagination logic (frontend)

  const totalPages =
    cardData.length > 0
      ? Math.ceil((cardData.length + 1) / pageSize) // add +1 for "Find More Classes"
      : 1;

  const paginatedData = cardData.slice((page - 1) * pageSize, page * pageSize);

  // remove all item from wishlist
  const handleRemoveAllItem = async (classId) => {
    try {
      const response = await removeWishlistAllItem(userId);

      if (response.status === 200) {
        // showSnackbar(response.message, "success");
        handleCloseConfirmaton();
        handleOpenSuccessPopup();

        //  update redux
        dispatch({ type: CLEAR_WISHLIST });

        // update local UI
        setCardData([]);

        // setTimeout(() => {
        //   dispatch({ type: CLEAR_WISHLIST });

        //   // update local UI
        //   setCardData([]);
        //   handleCloseConfirmaton();
        //   window.location.reload();
        // }, 1500);
      } else if ([400, 401, 500].includes(response.status)) {
        showSnackbar(response.message || "Something went wrong", "error");
      }
    } catch (error) {
      showSnackbar("Something went wrong", "error");
    }
  };

  const handleOpenConfirmaton = () => {
    setOpenConfirmation(true);
  };

  const handleCloseConfirmaton = () => {
    setOpenConfirmation(false);
  };

  const handleOpenSuccessPopup = () => {
    setOpenSuccesPopup(true);
  };

  const handleCloseSuccessPopup = () => {
    setOpenSuccesPopup(false);
  };

  const handleNavigateToClass = (classData) => {
    navigate('/test-prep/packages', {
      state: { classData },
    });
  };
  return (
    <>
      <Grid container spacing={2}>
        {/* Header */}
        <Grid item xs={12} sm={6}>
          <Typography
            fontSize="30px"
            color="#572575"
            sx={{
              fontWeight: 400,
              fontFamily: "Inter",
              lineHeight: "100%",
            }}
          >
            My Wishlist
          </Typography>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          container
          justifyContent="end"
          alignItems="center"
          gap={1}
        >
          {cardData?.length === 0 ? (
            <>
              <InfoOutlinedIcon style={{ color: "#FAAE2D" }} />
              <Typography
                fontSize="14px"
                color="#555555"
                fontFamily="Inter"
              >
                "No classes for enrollment"{" "}
              </Typography>
            </>
          ) : (
            <Button
              variant="outlined"
              onClick={handleOpenConfirmaton}
              style={{
                background: "#ffffff",
                color: "#572575",
                borderColor: "#E7CEF6",
                borderRadius: "10px",
                fontSize: "16px",
                fontFamily: "Inter",
                height: "32px",
                fontWeight: 600,
              }}
            >
              Remove All
            </Button>
          )}
        </Grid>

        {/* Content */}
        <Grid item xs={12}>
          {loading ? (
            <Loader text="Loading ..." />
          ) : !loading && cardData?.length > 0 ? (
            <Grid container spacing={5}>
              <>
                {paginatedData.map((data) => (
                  <>
                    <Grid item xs={12} sm={12} md={4} xl={3} key={data.id}>
                      <GlobalCard height="100%">
                        <Grid container spacing={1}>
                          <Grid item xs={12} mb={1}>
                            <Box
                              sx={{
                                width: "100%",
                                height: "100%",
                                overflow: "hidden",
                              }}
                            >
                              <img
                                src={data?.image_path?.image_src}
                                alt="IELTS Coaching"
                                style={{
                                  width: "100%",
                                  height: "100%",
                                  objectFit: "cover",
                                }}
                              />
                            </Box>
                          </Grid>

                          <Grid item xs={6} mb={1}>
                            <Typography
                              fontSize="20px"
                              color="#9D0385"
                              fontFamily="Inter"
                            >
                              {data?.test_type_id?.name}
                            </Typography>
                          </Grid>
                          {/* Delivery Mode */}
                          <Grid
                            item
                            xs={6}
                            sm={6}
                            mb={1}
                            sx={{ textAlign: { xs: "start", sm: "end" } }}
                            container
                            alignItems="center"
                            justifyContent="end"
                          >
                            <Box
                              display="inline-flex"
                              alignItems="center"
                              gap={1}
                              px={1.5}
                              py={0.4}
                              backgroundColor={
                                data?.mode_of_delivery === "online"
                                  ? "#DBEDFF"
                                  : "#FFEADE"
                              }
                              borderRadius="23px"
                            >
                              <Box
                                sx={{
                                  width: "8px",
                                  height: "8px",
                                  backgroundColor:
                                    data?.mode_of_delivery === "online"
                                      ? "#007BFF"
                                      : "#E65100",
                                  borderRadius: "50%",
                                }}
                              />
                              <Typography
                                fontSize="12px"
                                color={
                                  data?.mode_of_delivery === "online"
                                    ? "#007BFF"
                                    : "#E65100"
                                }
                                textTransform="capitalize"
                              >
                                {data?.mode_of_delivery}
                              </Typography>
                            </Box>
                          </Grid>

                          {/* Time */}

                          <Grid item xs={12} sm={4} lg={5} mb={1}>
                            <Box display="flex" alignItems="center">
                              <Box width={15} mr={0.5}>
                                <img src="/newdashboard/Wishlist/Group 1171283306.png" />
                              </Box>
                              <Typography
                                sx={{
                                  color: "#000",
                                  fontSize: 12,
                                  fontWeight: 500,
                                }}
                              >
                                {data?.start_time} - {data?.end_time}
                              </Typography>
                            </Box>
                          </Grid>





                          {/* Location */}
                          <Grid item xs={12} sm={8} lg={7} mb={1}>
                            <Box display="flex" alignItems="center" justifyContent={{xs:"start" ,sm:"end"}} >
                              <Box width={15} mr={0.5}>
                                <img src="/newdashboard/Wishlist/Group 1171283306 (1).png" />
                              </Box>
                              <Typography
                                sx={{
                                  color: "#000",
                                  fontSize: 12,
                                  fontWeight: 500,
                                }}
                              >
                                {data?.mode_of_delivery === "offline"
                                  ? data?.branch_id?.branch_name
                                  : "Online Class"}
                              </Typography>
                            </Box>
                          </Grid>

                          {/* Days */}
                          <Grid item xs={12}>
                            <Box display="flex" alignItems="center">
                              <Box width={15} mr={0.5}>
                                <img src="/newdashboard/Classes/Frame (1).png" />
                              </Box>
                              <Typography
                                sx={{
                                  color: "#000",
                                  fontSize: 12,
                                  fontWeight: 500,
                                }}
                              >
                                {data?.day?.map(day => day).join(", ")}

                              </Typography>
                            </Box>
                          </Grid>

                          {/* Buttons */}
                          <Grid
                            item
                            xs={12}
                            mt={1}
                            container
                            justifyContent="center"
                            gap={3}
                          >
                            <Button
                              variant="outlined"
                              onClick={() => handleRemoveOneItem(data.id)}
                              style={{
                                background: "#fff",
                                color: "#572575",
                                borderColor: "#572575",
                                borderRadius: "8px",
                                fontSize: "16px",
                                fontFamily: "Inter",
                                height: "32px",
                              }}
                              sx={{
                                width: { xs: "100%", sm: "45%" },
                              }}
                            >
                              Remove
                            </Button>
                            {!data?.is_active_enrolled && (
                              <Button
                                variant="contained"
                                onClick={() => handleNavigateToClass(data)}
                                style={{
                                  background: "#572575",
                                  borderRadius: "8px",
                                  fontSize: "16px",
                                  fontFamily: "Inter",
                                  height: "32px",
                                }}
                                sx={{
                                  width: { xs: "100%", sm: "45%" },
                                }}
                              >
                                Enroll Now
                              </Button>
                            )}

                            {data?.is_active_enrolled && (
                              <Tooltip title="You already enrolled in this class">
                                <Box sx={{
                                  width: { xs: "100%", sm: "45%" },
                                }}>
                                  <Button
                                    variant="contained"
                                    disabled
                                    style={{
                                      background: "#572575",
                                      borderRadius: "8px",
                                      fontSize: "16px",
                                      fontFamily: "Inter",
                                      height: "32px",
                                      opacity: "20%",
                                      color: "#ffffff"
                                    }}
                                    sx={{
                                      width: { xs: "100%", sm: "100%" },
                                    }}
                                  >
                                    Enroll Now
                                  </Button>
                                </Box>
                              </Tooltip>
                            )}
                          </Grid>
                        </Grid>
                      </GlobalCard>
                    </Grid>
                  </>
                ))}

                {/* Extra Card at the End */}
                {/* Show only on last page, and only if there’s some data */}
                {cardData.length > 0 && page === totalPages && (
                  <Grid item xs={12} sm={12} md={4}>
                    <GlobalCard height="100%">
                      <Grid
                        container
                        direction="column"
                        justifyContent="center"
                        alignItems="center"
                        spacing={2}
                        sx={{ textAlign: "center" }}
                        position="relative"
                      >
                        {/* Image */}
                        <Grid item>
                          <img
                            src="/newdashboard/Wishlist/13744794_Mar-Business_2.png" // 👈 replace with actual path
                            alt="Find More Classes"
                            style={{ objectFit: "contain" }}
                          />
                        </Grid>

                        {/* Title */}
                        <Grid item>
                          <Typography
                            fontSize="18px"
                            fontWeight={600}
                            color="#572575"
                            fontFamily="Inter"
                          >
                            Find More Classes
                          </Typography>
                          <Typography
                            fontSize="14px"
                            color="#572575"
                            fontFamily="Inter"
                            mt={1}
                          >
                            Explore and add new classes to your wishlist
                          </Typography>
                        </Grid>

                        <Grid item sx={{ width: "100%" }}>
                          <Button
                            variant="contained"
                            color="secondary"
                            startIcon={<SearchIcon />}
                            onClick={() => navigate("/test-prep/classes")}
                            style={{
                              background: "#572575",
                              fontWeight: 500,
                              borderRadius: "8px",
                              fontSize: "16px",
                              paddingLeft: 20,
                              paddingRight: 20,
                              fontFamily: "Inter",
                              height: "32px",
                              color: "#ffffff",
                              "&:hover": {
                                textDecoration: "none",
                              },
                            }}
                            sx={{
                              width: {
                                xs: "100%", // full width on small screens
                                sm: "80%", // 48% from 'sm' breakpoint and up
                                md: "70%",
                              },
                            }}
                          >
                            Explore Classes
                          </Button>{" "}
                        </Grid>
                      </Grid>
                    </GlobalCard>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <CustomPafinationComp
                    currentPage={page}
                    totalPages={totalPages}
                    onPageChange={setPage}
                  />
                </Grid>
              </>
            </Grid>
          ) : !loading && cardData?.length === 0 ? (
            <WishlistEmpty />
          ) : (
            <Loader text="Loading ..." />
          )}
        </Grid>
      </Grid>

    

      <ConfimationPopup
        handleClose={handleCloseConfirmaton}
        component={
          <DeleteAllConfirmation
            handleClose={handleCloseConfirmaton}
            handleRemoveAllItem={handleRemoveAllItem}
          />
        }
        open={openConfimation}
        subtitle=""
        maxWidth="sm"
      />

      <ConfimationPopup
        handleClose={handleCloseSuccessPopup}
        component={
          <GlobalMessageModal
            handleClose={handleCloseSuccessPopup}
            // handleRemoveAllItem={handleRemoveAllItem}
            text="All Classes Successfully Removed !"
            subText="All your classes have been successfully removed."
            buttonTitle="View Classes"
            startIcon={<MenuBookIcon />}
            navigateLink="/test-prep/classes"
          />
        }
        open={openSuccesPopup}
        subtitle=""
        maxWidth="sm"
      />
    </>
  );
}
